import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import * as Styled from "./choice-columns.style";
/** The panel is as narrow as the columns allow. */
export var choiceColumnsPanelWidth = "fit-content";
var optionCenter = function (index) {
    return index * (Styled.optionHeight + Styled.optionGap) + Styled.optionHeight / 2;
};
/* Runs from the picked option on the left, across the middle of the gap, to
 * the picked option on the right. */
var connectorPath = function (fromIndex, toIndex) {
    var half = Styled.columnGap / 2;
    return "M0 ".concat(optionCenter(fromIndex), " H").concat(half, " V").concat(optionCenter(toIndex), " H").concat(Styled.columnGap);
};
/**
 * Picks an item column by column, e.g. a pump by nozzle, size and features,
 * with a line through the picked option of each column, as they make up one
 * item together, ending at the item's image.
 */
export var ChoiceColumns = function (_a) {
    var columns = _a.columns, thumbnail = _a.thumbnail, summary = _a.summary;
    var selectedIndices = columns.map(function (column) {
        return column.options.findIndex(function (option) { return option.isSelected; });
    });
    var lastSelectedIndex = selectedIndices[selectedIndices.length - 1];
    var shownThumbnail = lastSelectedIndex >= 0 ? thumbnail : undefined;
    return (_jsxs(Styled.Root, { children: [_jsxs(Styled.Grid, { columnCount: columns.length, hasThumbnail: !!shownThumbnail, children: [columns.map(function (column) { return (_jsx(Styled.Header, { children: column.header }, column.header)); }), columns.map(function (column, columnIndex) {
                        var from = selectedIndices[columnIndex - 1];
                        var to = selectedIndices[columnIndex];
                        return (_jsxs(Styled.Column, { children: [columnIndex > 0 && from >= 0 && to >= 0 && (_jsx(Styled.Connector, { "aria-hidden": true, children: _jsx("path", { d: connectorPath(from, to) }) })), column.options.map(function (option) {
                                    var _a;
                                    return (_jsx(Styled.Option, { isSelected: option.isSelected, onClick: option.onSelect, role: "button", "aria-label": (_a = option.name) !== null && _a !== void 0 ? _a : "".concat(column.header, " ").concat(option.label), "aria-pressed": option.isSelected, tabIndex: 0, children: option.label }, option.label));
                                })] }, column.header));
                    }), shownThumbnail && (_jsxs(Styled.Thumbnail, { top: optionCenter(lastSelectedIndex) - Styled.thumbnailSize / 2, children: [_jsx(Styled.Connector, { "aria-hidden": true, children: _jsx("path", { d: "M0 ".concat(Styled.thumbnailSize / 2, " H").concat(Styled.columnGap) }) }), _jsx("img", { src: shownThumbnail, alt: "" })] }))] }), summary && _jsx(Styled.Summary, { children: summary })] }));
};
